import { render } from "./stats.vue?vue&type=template&id=6518586f&scoped=true"
import script from "./stats.vue?vue&type=script&lang=js"
export * from "./stats.vue?vue&type=script&lang=js"

import "./stats.vue?vue&type=style&index=0&id=6518586f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6518586f"]])

export default __exports__